<template>
  <section class="match-players columns has-text-centered">
    <router-link :to="{name: 'User', params: { username: playerOne.User.username }}"
                 class="player column is-two-fifths"
                 :style="playerOneBackground">
      {{ playerOne.User.username }}
    </router-link>
    <div class="match-scores column is-one-fifth">
      <span :class="playerOneScoreClass">
        {{ playerOne.gobPosition }}
      </span>
      <span class="between-score"></span>
      <span :class="playerTwoScoreClass">
        {{ playerTwo.gobPosition }}
      </span>
    </div>
    <router-link :to="{name: 'User', params: { username: playerTwo.User.username }}"
                 class="player column is-two-fifths"
                 :style="playerTwoBackground">
      {{ playerTwo.User.username }}
    </router-link>
  </section>
</template>

<script>
export default {
  props: {
    playerOne: {
      required: true,
      type: Object
    },
    playerTwo: {
      required: true,
      type: Object
    }
  },
  computed: {
    playerOneBackground () {
      return {
        backgroundImage: 'linear-gradient(141deg, #' +
          this.playerOne.User.color1 +
          ', #' +
          this.playerOne.User.color2 +
          ')'
      }
    },
    playerTwoBackground () {
      return {
        backgroundImage: 'linear-gradient(141deg, #' +
        this.playerTwo.User.color1 +
        ', #' +
        this.playerTwo.User.color2 +
        ')'
      }
    },
    playerOneScoreClass () {
      if (this.playerOne.winner) {
        return 'winner'
      }
      return 'loser'
    },
    playerTwoScoreClass () {
      if (this.playerTwo.winner) {
        return 'winner'
      }
      return 'loser'
    }
  }
}
</script>

<style scoped>
  .match-players {
    margin-top: 40px;
  }
  .match-scores {
    padding: 0 !important;
    font-size: 2em;
  }
  .winner {
    color: #8fc93a;
  }
  .loser {
    color: #e43f6f;
  }
  .between-score {
    margin: 0 40px;
  }
  .player {
    height: 50px;
    color: white;
  }
</style>



// WEBPACK FOOTER //
// src/components/MatchPlayers.vue